import { api } from "../lib/apiClient";

export async function validateInviteCode(code) {
  const { data } = await api.get(`/invites/validate/${code}`);
  return data;
}
